import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class BriefingDateStyleFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    allowExpertMode?: boolean = true;
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
